module.exports = __webpack_public_path__ + "img/Fluid.fa37c004.jpg";